import _defineProperty from "/home/runner/work/documentation/documentation/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Box from './Box';
import { BORDER } from './constants';
import sx from './sx';
import theme from './theme';
var BorderBox = styled(Box).withConfig({
  displayName: "BorderBox",
  componentId: "oreju5-0"
})(["", ";", ";"], BORDER, sx);
BorderBox.defaultProps = {
  theme: theme,
  borderWidth: '1px',
  borderStyle: 'solid',
  borderColor: 'gray.2',
  borderRadius: 2
};
BorderBox.propTypes = _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, Box.propTypes), BORDER.propTypes), sx.propTypes), {}, {
  theme: PropTypes.object
});
export default BorderBox;